// extracted by mini-css-extract-plugin
export default {"mobile-preloader":"mobile-preloader--9l7k"};